import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, P } from "../../../AbstractElements";
import { ARTICAL_AND_VIDEO_1 } from "../../../Data/Knowledgebase";

export const ArticalAndVideo1 = () => {
  return (
    <Col xl="4" md="6">
      <Row>
        {ARTICAL_AND_VIDEO_1.map((item, index) => (
          <Col sm="12" key={index}>
            <Card>
              <CardBody>
                <div className="d-flex">
                  {item.iconClass}
                  <div className="flex-grow-1">
                    <H4 className="f-w-700">{item.title}</H4>
                    <P>{item.description}</P>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
